module.exports = __webpack_public_path__ + "img/horror.cfd732a3.svg";